import React from "react";
import ContactForm from "../../components/contact-form";
import "./contact.scss";

const MailIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
        <polyline points="22,6 12,13 2,6"></polyline>
    </svg>
);

const PhoneIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
    </svg>
);

const MapPinIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
        <circle cx="12" cy="10" r="3"></circle>
    </svg>
);

const SendIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <line x1="22" y1="2" x2="11" y2="13"></line>
        <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
    </svg>
);

const TwitterIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"></path>
    </svg>
);

const SendMsgIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <path d="M21.15 3.65a2 2 0 0 0-2.28-.27L2.86 11a2 2 0 0 0-.1 3.56l8.47 3.39 3.39 8.47a2 2 0 0 0 3.56-.1l7.67-16a2 2 0 0 0-.7-2.67zM12 14l9-9"></path>
    </svg>
); // Telegram-ish

const GithubIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"></path>
    </svg>
);

const ContactContainer = () => {
    return (
        <section className="contact-saas-section" id="contact">
            <div className="container">
                <div className="contact-header">
                    <span className="sub-title">Get in Touch</span>
                    <h2 className="main-title">
                        Available for{" "}
                        <span className="highlight">Exciting Projects</span>
                        <br /> and Collaborations
                    </h2>
                    <p className="description">
                        Have a project in mind or just want to verify my skills?
                        Feel free to reach out. I&apos;m always open to
                        discussing new ideas and opportunities.
                    </p>
                </div>

                <div className="contact-grid">
                    {/* Left Side: Info */}
                    <div className="contact-info-modern">
                        <div className="info-card">
                            <div className="icon-box">
                                <MailIcon />
                            </div>
                            <div className="info-content">
                                <h4>Email Me</h4>
                                <a href="mailto:dev.sajid09@gmail.com">
                                    dev.sajid09@gmail.com
                                </a>
                            </div>
                        </div>

                        <div className="info-card">
                            <div className="icon-box">
                                <PhoneIcon />
                            </div>
                            <div className="info-content">
                                <h4>Call Me</h4>
                                <a href="tel:+8801605688548">
                                    (+880) 160 5688 548
                                </a>
                            </div>
                        </div>

                        <div className="info-card">
                            <div className="icon-box">
                                <MapPinIcon />
                            </div>
                            <div className="info-content">
                                <h4>Location</h4>
                                <p>Gazipur, Dhaka, Bangladesh</p>
                            </div>
                        </div>

                        <div className="social-connect">
                            <h4>Connect with me</h4>
                            <div className="social-icons-modern">
                                <a
                                    href="https://x.com/sajid59602831"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label="Twitter"
                                >
                                    <TwitterIcon />
                                </a>
                                <a
                                    href="https://t.me/sajidrds"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label="Telegram"
                                >
                                    <SendMsgIcon />
                                </a>
                                <a
                                    href="https://api.whatsapp.com/send/?phone=%2B8801605688548&text=Hello+Sajid/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label="WhatsApp"
                                >
                                    <PhoneIcon />
                                </a>
                                <a
                                    href="https://github.com/ReXiOP"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label="Github"
                                >
                                    <GithubIcon />
                                </a>
                            </div>
                        </div>
                    </div>

                    {/* Right Side: Form */}
                    <div className="modern-contact-form-wrapper">
                        <h3>Send me a message</h3>
                        <ContactForm />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ContactContainer;
